<div class="row row-header">
	<div class="col">

		<h1 data-testid="SUBSYS5_PUBLISH_TITLE_TXT" class="mb-5">{{ labels().PUBLISH_COMPONENT_TITLE }}</h1>

		<tsp-plan-header [plan]="plan()!" />

	</div>
</div>

<div class="row row-contents">
	<div class="col-12">
		<ul class="nav nav-tabs nav-tabs-list justify-content-center" role="tablist">
			<li>
				<a data-testid="SUBSYS5_PUBLISH_PLANSETTINGS_TAB" class="tab text-decoration-none" id="tab-plan"
					[routerLink]="PAGE.PUBLISH_PLAN" [queryParams]="{ planGuid: planGuid() }" routerLinkActive="active"
					role="tab">
					{{ labels().PUBLISH_COMPONENT_TAB_PLAN_SETTINGS }}
				</a>
			</li>
			<li [class.disabled]="!isNextEnabled()">
				<a data-testid="SUBSYS5_PUBLISH_PATIENTSETTINGS_TAB" class="tab text-decoration-none" id="tab-patient"
					[routerLink]="PAGE.PUBLISH_PATIENT" [queryParams]="{ planGuid: planGuid() }" routerLinkActive="active"
					role="tab" [class.pe-none]="!isNextEnabled()">
					{{ labels().PUBLISH_COMPONENT_TAB_PATIENT_SETTINGS }}
				</a>
			</li>
		</ul>
	</div>
	<div class="col-12 bg-tab-gradient"></div>
</div>

<div class="row row-contents">
	<div class="col">

		@if (isPatientTab) {
		<tsp-publish-patient />
		} @else {
		<tsp-publish-plan />
		}

		<div class="bottom-bar-save bottom-bar-save-plan">
			<button data-testid="SUBSYS5_PUBLISH_CANCEL_BTN" type="button" class="btn btn-secondary-outline"
				[class.me-3]="isPatientTab" (click)="cancel()">
				{{ labels().PUBLISH_COMPONENT_CANCEL_BTN }}
			</button>
			@if (isPatientTab) {
			<button data-testid="SUBSYS5_PUBLISH_PREVIOUS_BTN" type="button" class="btn btn-secondary-outline"
				(click)="prev()">
				{{ labels().PUBLISH_COMPONENT_PREVIUOS_BTN }}
			</button>
			<button data-testid="SUBSYS5_PUBLISH_PUBLISH_BTN" type="button" class="btn btn-primary"
				[disabled]="!isPublishEnabled()" (click)="publish()">
				{{ labels().PUBLISH_COMPONENT_PUBLISH_BTN }}
			</button>
			} @else {
			<button data-testid="SUBSYS5_PUBLISH_NEXT_BTN" type="button" class="btn btn-primary" [disabled]="!isNextEnabled()"
				(click)="next()">
				{{ labels().PUBLISH_COMPONENT_NEXT_BTN }}
			</button>
			}
		</div>
	</div>
</div>